function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTennis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65237 10.7592C9.22181 10.7592 11.3047 8.68655 11.3047 6.12983C11.3047 3.57312 9.22181 1.50049 6.65237 1.50049C5.58834 1.50049 4.60772 1.85592 3.82392 2.45398C4.93366 3.30006 5.64926 4.63234 5.64926 6.13092C5.64926 7.62887 4.93427 8.96064 3.82534 9.80677C4.60891 10.4042 5.58898 10.7592 6.65237 10.7592ZM8.3749 6.1307C8.3749 7.44521 9.02607 8.60838 10.025 9.31825C9.85654 9.4947 9.67428 9.65794 9.47993 9.80627C8.37121 8.96013 7.65637 7.62848 7.65637 6.1307C7.65637 4.63291 8.37121 3.30127 9.47993 2.45512C9.67428 2.60345 9.85654 2.76669 10.025 2.94314C9.02607 3.65301 8.3749 4.81618 8.3749 6.1307Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6.12983C2 7.36583 2.4868 8.4887 3.28002 9.31895C4.27928 8.60912 4.93074 7.44572 4.93074 6.13092C4.93074 4.81558 4.27874 3.65176 3.27878 2.94201C2.48629 3.77214 2 4.89448 2 6.12983Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87367 11.1262C8.43172 11.2854 7.96218 11.3873 7.47412 11.423C7.47542 11.6475 7.46319 11.9558 7.41088 12.3033C7.3036 13.0162 7.03401 13.8546 6.40943 14.4925L3.8269 17.0622C3.62768 17.2604 3.62768 17.5818 3.8269 17.78L4.40147 18.3518C4.60077 18.5501 4.92395 18.5501 5.12324 18.3518L7.67764 15.81C8.32194 15.1689 9.17884 14.8945 9.90581 14.7862C10.2658 14.7325 10.5839 14.7212 10.8111 14.7234C10.84 14.7237 10.8674 14.7242 10.8932 14.7248C11.2746 14.7629 11.6695 14.754 12.0686 14.6999C13.4017 14.5193 14.7944 13.8346 15.9382 12.6965C17.082 11.5583 17.7701 10.1725 17.9516 8.84614C18.1331 7.51958 17.8081 6.2411 16.9085 5.34604C16.009 4.45096 14.7241 4.12743 13.3908 4.3081C12.9624 4.36616 12.5278 4.47627 12.0973 4.63676C12.2037 4.97208 12.2769 5.322 12.3133 5.68274C13.7468 5.06856 15.244 5.17103 16.1642 6.08609C17.4985 7.41281 17.1149 9.94524 15.3075 11.7425C13.5 13.5397 10.9531 13.9211 9.61881 12.5944C9.21829 12.1961 8.97256 11.6892 8.87367 11.1262ZM7.23666 14.7939C7.67375 14.2565 7.93219 13.6505 8.08403 13.0886C8.21752 13.293 8.37294 13.485 8.55084 13.662C8.72474 13.835 8.91304 13.9867 9.1133 14.1175C8.54962 14.2687 7.942 14.5256 7.40307 14.9595L7.23666 14.7939Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTennis);
export default __webpack_public_path__ + "static/media/icon-tennis.9a493d6df0d89781363123fa69efb613.svg";
export { ForwardRef as ReactComponent };